module.exports = __webpack_public_path__ + "img/copy-link-to-screen.4b33c435.gif";